export default __webpack_public_path__ + "static/media/card-image9.3a8b40d4.png";